<div [ngClass]="hasDimmBack === true? 'main-container':'noDimm'" (click)="closeBackground()"></div>


<div class="booking-view-container">
  <app-loader *ngIf="isSpinning"></app-loader>

  <div class="filter-section">
    <div class="date-select-section">

      <div class="form-group date-range">
        <app-mis-datepicker class="date-position" [singleDateEnabled]="false" [config]="dateMaxConfig"
          (selectedDate)="selectedDate($event)"></app-mis-datepicker>
        <div class="booking-view-invalid-date" *ngIf="displayInvalidDateError">Invalid date range</div>
      </div>

      <div class="booking-type-filter header-item filter-card"
        *ngIf="bookingTypeConfig && bookingTypeConfig.config.visibility.visible">
        <app-multiselect *ngIf="bookingFilterConfig" [width]="'150px'" [dropdownListWidth]="'181px'"
          [label]="bookingTypeConfig.config.displayName" [formControl]="formDetails.get('bookingType')"
          [options]="bookingTypeConfig.config.values" (handleApplyFilters)="handleApplyFilters()" 
          [showSelectedFilter]="true" [isEmitAllowed]="true"> 
        </app-multiselect>
      </div>
      <div class="office-filter header-item filter-card" *ngIf="officeConfig && officeConfig.config.visibility.visible">
        <app-multiselect *ngIf="bookingFilterConfig" [width]="'140px'" [dropdownListWidth]="'150px'"
          [label]="officeConfig.config.displayName" [formControl]="formDetails.get('office')"
          [options]="officeConfig.config.values" (handleApplyFilters)="handleApplyFilters()"
          [showSelectedFilter]="true" [isEmitAllowed]="true">
        </app-multiselect>
      </div>

      <div class="city-filter header-item filter-card" *ngIf="cityConfig && cityConfig.config.visibility.visible">
        <app-multiselect *ngIf="bookingFilterConfig" [width]="'140px'" [dropdownListWidth]="'181px'"
          [label]="cityConfig.config.displayName" [formControl]="formDetails.get('city')"
          [options]="cityConfig.config.values" (handleApplyFilters)="handleApplyFilters()"
          [showSelectedFilter]="true" [isEmitAllowed]="true">
        </app-multiselect>
      </div>

      <div class="vendor-cab-status-filter header-item filter-card"
        *ngIf="vendorCabStatusConfig && vendorCabStatusConfig.config.visibility.visible">
        <app-multiselect *ngIf="bookingFilterConfig" [width]="'190px'" [dropdownListWidth]="'231px'"
          [label]="vendorCabStatusConfig.config.displayName" [formControl]="formDetails.get('vendorCabStatus')"
          [options]="vendorCabStatusConfig.config.values" (handleApplyFilters)="handleApplyFilters()"
          [showSelectedFilter]="true" [isEmitAllowed]="true">
        </app-multiselect>
      </div>

      <div class="header-item filter-card"
        *ngIf="cabTypeConfig && cabTypeConfig.config.visibility.visible">
        <app-multiselect *ngIf="bookingFilterConfig" [width]="'140px'" [dropdownListWidth]="'231px'"
          [label]="cabTypeConfig.config.displayName" [formControl]="formDetails.get('cabTypes')"
          [options]="cabTypeConfig.config.values" (handleApplyFilters)="handleApplyFilters()"
          [showSelectedFilter]="true" [isEmitAllowed]="true">
        </app-multiselect>
      </div>

      <div class="header-item filter-card">
        <app-time-range-picker
        [timeRangeControl]="formDetails.get('timeRange')"
        [givenStartTimeAt24]="'00:00'"
        [givenEndTimeAt24]="'23:59'"
        [isTwelveHr]="miscelleneousConfig['12hrTimeFormat']"
        (valueChanged)="handleApplyFilters()"
        [isSameDateRange]="isSameDateRange"
        ></app-time-range-picker>
      </div>

      <!-- ----marshall filter  -->
      <!-- <div class="vendor-cab-status-filter header-item filter-card"
        *ngIf="marshallStatusConfig && marshallStatusConfig.config.visibility.visible">
        <app-multiselect *ngIf="bookingFilterConfig" [width]="'182px'" [dropdownListWidth]="'231px'"
          [label]="marshallStatusConfig.config.displayName" [formControl]="formDetails.get('marshallStatus')"
          [options]="marshallStatusConfig.config.values" (handleApplyFilters)="handleApplyFilters()">
        </app-multiselect>
      </div> -->
    </div>


   
      <mis-dropdown [data]="reports" height="36px" width="160px" label="Download Reports" dropdownListHeight="126px"
      (onChange)="downloadReport($event)" dropdownListPosition="Left" [searchEnabled]="false" 
    ></mis-dropdown>
   

    <!-- <div class="download-icons-container">
      <button mis-button type="none" size="lg" class="button" (click)="handleDownlodSignInReport()">
        <span mis-input-icon class="btn-icon"><img src="/assets/images/download-report.svg" alt="" /></span>
        SignIn Report
      </button>
      <button mis-button type="none" size="lg" class="button" (click)="handleDownloadBookingReport()">
        <span mis-input-icon class="btn-icon"><img src="/assets/images/download-report.svg" alt="" /></span>
        Booking Report
      </button>
      <button *ngIf="generateBillingAccess" mis-button type="none" size="lg" class="button" (click)="handleDownloadGenerateReport()">
        <span mis-input-icon class="btn-icon"><img src="/assets/images/download-report.svg" alt="" /></span>
         Billing Report
      </button>
    </div> -->


  </div>

  <div class="search-actions-wrapper">
    <app-booking-actions-header *ngIf="config" [searchInput]="searchInput" [vendors]="vendors" [state]="state"
      [startDate]="startDate" [endDate]="endDate" [filterFormDetails]="formDetails"
      [selectedBookings]="selectedBookings" [cancelCutOffDetails]="cancelCutOffDetails"
      [selectedBookingDetailed]="selectedBookingDetailed" [totalNoOfTrips]="summaryData && summaryData.totalTrips"
      [tripsWithNoVendors]="summaryData && summaryData.vendorNotAssigned"
      [tripsWithNoCabs]="summaryData && summaryData.cabNotAssigned"
      [cancelledTrips]="summaryData && summaryData.cancelledTrips" [assignVendor]="" [config]="config" [now]="now"
      [vendorSelectConfigObj]="vendorSelectConfigObj" [downloadCallback]="getDownloadReport"
      (searchInputChangeCallBack)="onSearchInputChange($event)"
      (handleBookingsUpdateCallback)="handleBookingUpdate($event)" (toggleLoadingCallBack)="toggleLoading($event)"
      (getDetailsCallback)="getBookingDetails()" (showCancelBookingSuccessCallback)="showCancelBookingSuccess()"
      (showCancelBookingErrorCallback)="showCancelBookingErrors($event)"
      (selectedBookingsVendorValuesReset)="selectedBookingsVendorValuesReset($event)"
      (toggleAutoReload)="toggleAutoReload($event)" (showSuccessToast)="showSuccessToast($event)"
      (mergeBookingCallback)="replaceMergedBookings($event)" [showCheckboxHyphen]="showCheckboxHyphen"
      [allBookingsSelected]="allBookingsSelected" (checkboxSelected)="handleAllBookingsSelected($event)"
      (selectVendorAssigned)="selectVendorAssignedBookings()"
      (selectVendorUnAssigned)="selectVendorUnAssignedBookings()"
      [marshallNotAssigned]="summaryData && summaryData.marshalNotAssigned" [miscelleneousConfig]="miscelleneousConfig"
       [multiDayBookings]="summaryData && summaryData?.multiDayBookings"
       [tripCompleted]="summaryData && summaryData?.tripCompleted"
        >
    </app-booking-actions-header>
  
  </div>

  <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

  <!-- Position Column -->

  <div class="table-data">
    <div class="table-container">

      <div class="table">
        <app-table-skeleton *ngIf="isLoading; else showPage"></app-table-skeleton>
        <ng-template #showPage>
          <div class="booking-list-wrapper">
            <div class="bookings-table-wrapper">
              <table class="bookings-details-table" *ngIf="tabularConfigKeys?.length">
                <thead class="bookings-table-head">
                  <th class="column-heading" style="border-left: 0;">

                  </th>
                  <ng-container *ngFor="let key of tabularConfigKeys">
                  <th class="column-heading" *ngIf="tabularConfigObj.get(key).visibility?.visible && key !== 'Trip Date' " 
                    [ngStyle]="key=='Booking ID'? {'width':'138px'}:{}">
                    {{tabularConfigObj.get(key).displayName}}</th>
                  <th class="column-heading cursor-pointer date"
                    *ngIf="tabularConfigObj.get(key).visibility.visible && key === 'Trip Date'" (click)="sortBookings()">
                    <div class="trip-date">
                      {{tabularConfigObj.get(key).displayName}}
                      <div class="sort">
                        <div class="dropdown-up-icon" [ngClass]="{'disabled': !sortAscending}"></div>
                        <div class="dropdown-down-icon" [ngClass]="{'disabled': sortAscending}"></div>
                      </div>
                    </div>
                  </th>
                  </ng-container>
                  <th class="column-heading" style="min-width:108px;"> Status</th>
                  <th class="column-heading">Actions</th>
                </thead>

                <tbody class="table-body">
                  <ng-container *ngIf="vendorSelectConfigObj && vendorCabSelectFormGroup">
                    <tr class="booking-row" 
                      *ngFor="let booking of bookingDetails; let i = index"
                      [ngStyle]="miscelleneousConfig.femaleRowHighlight && femaleRiderPresent(booking.stops) ? {'background':'#FBE6EF'}:{}">
                      <!-- style="padding: 0 !important;" -->
                      <td 
                      
                        [ngClass]="{'cancelled-booking': booking.bookingStatus === 'CANCELLED' || (authService && (authService.user.role === 'VENDOR_MANAGER') && (booking.vendorStatus === 'CANCELLED' || booking.vendorStatus === 'DENIED'))}">
                        <div class="booking-row-info td-check align-item-center height-full " >
                         <div class="ml-4">
                          <app-checkbox
                          [checked]="selectedBookings.length ? isBookingChecked({id: booking.bookingId}) : false"
                          [checkboxValue]="booking.bookingId"
                          (checkboxSelectedCallback)="handleBookingsSelected($event)">
                          </app-checkbox>
                         </div>
                         <div class="displayFlex">
                          <span *ngIf="femaleRiderPresent(booking.stops)" class="femaleIndicator ribbon mr-2"  matTooltip="Female passenger(s)" matTooltipClass="booking-table-tooltip"></span>
                          <span *ngIf="booking.internationalRiderPresent" class="internationalIndicator ribbon"  matTooltip="International passenger(s)" matTooltipClass="booking-table-tooltip"></span>
                         </div>
                        </div>
                      </td>
                      <ng-container *ngFor="let key of tabularConfigKeys">
                                              <td
                        [ngClass]="{'cancelled-booking': booking.bookingStatus === 'CANCELLED' || (authService && (authService.user.role === 'VENDOR_MANAGER') && (booking.vendorStatus === 'CANCELLED' || booking.vendorStatus === 'DENIED'))}"
                        *ngIf="tabularConfigObj.get(key)?.visibility.visible && !['Booking ID','Request ID','Rider','vendor','Cab','Driver','billingType','JobTitle'].includes(key)"
                        >
                        <div class="ellipsis booking-row-info"  matTooltip="{{booking[columnMap[key]] || booking[key] || '--'}}"  matTooltipClass="booking-table-tooltip">{{booking[columnMap[key]] || booking[key] || '--'}}</div>
                                              </td>
                      
                       <td *ngIf="tabularConfigObj.get(key)?.visibility.visible && key=='JobTitle'" [ngClass]="{'cancelled-booking': booking.bookingStatus === 'CANCELLED' || (authService && (authService.user.role === 'VENDOR_MANAGER') && (booking.vendorStatus === 'CANCELLED' || booking.vendorStatus === 'DENIED'))}">
                          <div class="ellipsis booking-row-info"  matTooltip="{{getJobTitle(booking.stops) || '--'}}"  matTooltipClass="booking-table-tooltip">
                           {{getJobTitle(booking.stops) || '--'}}
                          </div>
                       </td>

                       <td 
                        [ngClass]="{'cancelled-booking': booking.bookingStatus === 'CANCELLED' || (authService && (authService.user.role === 'VENDOR_MANAGER') && (booking.vendorStatus === 'CANCELLED' || booking.vendorStatus === 'DENIED'))}"
                        *ngIf="key === 'Booking ID' && tabularConfigObj.get('Booking ID')?.visibility.visible">
                        <div class="booking-id-container">
                          <div class="booking-id "
                            [ngClass]="{'color-inherit' : tabularConfigObj.get('Booking ID').elementType === 'non-clickable'}"
                            [title]="booking.bookingId"
                            (click)="tabularConfigObj.get('Booking ID').elementType === 'clickable' ? openDrawer(booking) : ''">
                               {{booking.bookingId}}
                            <!-- {{booking.bookingId.split('').slice(0,2).join('')}}...{{booking.bookingId.split('').slice(booking.bookingId.length-3).join('')}} -->
                          </div>
                          
                          <ng-container *ngIf="getIcons(booking) as icons">
                            <div class="displayFlex">
                              <div *ngFor="let icon of icons; let i = index">
                                <span *ngIf="i < 3" >
                                  <img class="mr-2" [src]="icon.icon" matTooltip="{{icon.description}}" matTooltipClass="booking-table-tooltip">
                                </span>
                              </div>
                              <div *ngIf="icons.length>3">
                                <span class="iconCount " (mouseenter)="booking.isIconHovered = true" (mouseleave)="booking.isIconHovered = false">
                                  +{{ icons.length - 3 }}
                                </span>
                              </div>
                            </div>                       
                          
                            <ng-template [ngIf]="booking.isIconHovered">
                              <div class="riderList displayFlexColumn mt-64">
                                <div class="displayFlex" *ngFor="let icon of icons.slice(3)">
                                  <span><img [src]="icon.icon"></span>
                                  <span class="mr-4 ml-4">{{icon.description}}</span>
                                </div>
                              </div>
                            </ng-template>
                          </ng-container>
                        </div>
                       </td>
                       <td
                        [ngClass]="{'cancelled-booking': booking.bookingStatus === 'CANCELLED' || (authService && (authService.user.role === 'VENDOR_MANAGER') && (booking.vendorStatus === 'CANCELLED' || booking.vendorStatus === 'DENIED'))}"
                        *ngIf="key === 'Request ID' && tabularConfigObj.get(key)?.visibility.visible" [title]="booking.requestId">
                        <div class="ellipsis request-id"
                          [ngClass]="{'color-inherit' : tabularConfigObj.get('Request ID').elementType === 'non-clickable'}"
                          (click)="tabularConfigObj.get('Request ID').elementType === 'clickable' ? handleShowSingleRequestDetails(booking.requestId): ''">
                          {{booking.requestId}}
                        </div>
                       </td>
                       <td     
                        [ngClass]="{'cancelled-booking': booking.bookingStatus === 'CANCELLED' || (authService && (authService.user.role === 'VENDOR_MANAGER') && (booking.vendorStatus === 'CANCELLED' || booking.vendorStatus === 'DENIED')),'hovered': booking.isHovered}" 
                        *ngIf="key === 'Rider' && tabularConfigObj.get('Rider')?.visibility.visible"
                        (mouseenter)="booking.isHovered = true" (mouseleave)="booking.isHovered = false">
                        <div class=" booking-row-info displayFlexSpaceBetween align-item-center">
                          <span class="ellipsis" style="width: 75%;">
                            {{booking.riderNames?.split(',')[0] || '--'}} 
                          </span> 
                          <span [ngClass]="getCount(booking.stops) ? 'riderCount':''">{{getCount(booking.stops)}}</span> 
                        </div>
                        <div class="position-relative">
                        <ng-template [ngIf]="booking.isHovered">
                          <div class="riderList displayFlexColumn">
                            <div class="displayFlex" *ngFor="let rider of getRiderDertails(booking.stops)">
                              <span><img
                                  [src]="rider.gender == 'Male'? 'assets/Male.svg' : rider.gender=='Female' ? 'assets/Female.svg' : 'assets/Neutral.svg' "
                                  alt=""></span>
                              <span class="mr-4 ml-4"> {{rider.name}}</span>
                              <span *ngIf="rider.department"> ({{rider.department}})</span>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                       </td>
                       <td
                         [ngClass]="{'cancelled-booking': booking.bookingStatus === 'CANCELLED' || (authService && (authService.user.role === 'VENDOR_MANAGER') && (booking.vendorStatus === 'CANCELLED' || booking.vendorStatus === 'DENIED'))}"
                        *ngIf="key === 'vendor' && tabularConfigObj.get('vendor')?.visibility.visible">
                        <div class="ellipsis booking-row-info"  [matTooltip]="booking?.vendor?.vendorName || null"  matTooltipClass="booking-table-tooltip">
                          {{ booking?.vendor?.vendorName || '--'}}
                        </div>
                       </td>
                       <td
                        [ngClass]="{'cancelled-booking': booking.bookingStatus === 'CANCELLED' || (authService && (authService.user.role === 'VENDOR_MANAGER') && (booking.vendorStatus === 'CANCELLED' || booking.vendorStatus === 'DENIED'))}"
                        *ngIf="key === 'Cab' && tabularConfigObj.get('Cab')?.visibility.visible">
                        <div class="ellipsis booking-row-info"
                          [ngClass]="{'disabled': booking.bookingStatus === 'CANCELLED' || (authService && (authService.user.role === 'VENDOR_MANAGER') && (booking.vendorStatus === 'CANCELLED' || booking.vendorStatus === 'DENIED'))}"
                          matTooltip="{{getCabRegistration(booking)}}"  matTooltipClass="booking-table-tooltip">
                          <span *ngIf="booking.cabAllocCutOffStatus=='PASSED'; else cabReg" class="file-error white-space-break-spaces">CUT OFF PASSED</span>
                          <ng-template #cabReg><span> {{getCabRegistration(booking)}}</span></ng-template>
                        </div>
                       </td>

                       <!-- for showing driver name and phone in case of multidriver disable and also in case of virtual cab enable -->
                       <td *ngIf="key === 'Driver' && tabularConfigObj.get('Driver')?.visibility.visible" 
                       [ngClass]="{'cancelled-booking': booking.bookingStatus === 'CANCELLED' ||
                       (authService && (authService.user.role === 'VENDOR_MANAGER') &&
                       (booking.vendorStatus === 'CANCELLED' || booking.vendorStatus === 'DENIED'))}"
                        [title]="this.virtualCabDriverDetails[booking.bookingId] || getCabRegistration(booking, true)">
                        <div class="ellipsis booking-row-info pl-10" [ngClass]="{'disabled': booking.bookingStatus === 'CANCELLED'
                       || (authService && (authService.user.role === 'VENDOR_MANAGER') &&
                       (booking.vendorStatus === 'CANCELLED' || booking.vendorStatus === 'DENIED'))}">
                          {{ (this.virtualCabDriverDetails[booking.bookingId] || getCabRegistration(booking, true)) ?
                          (this.virtualCabDriverDetails[booking.bookingId] || getCabRegistration(booking, true)) : '--'}}
                        </div>
                       </td>

                       <td
                        [ngClass]="{'cancelled-booking': booking.bookingStatus === 'CANCELLED' || (authService && (authService.user.role === 'VENDOR_MANAGER') && (booking.vendorStatus === 'CANCELLED' || booking.vendorStatus === 'DENIED'))}"
                        *ngIf="key === 'billingType' && tabularConfigObj.get('billingType')?.visibility.visible"
                        >
                        <div 
                        class="ellipsis booking-row-info"  
                        [matTooltip]="booking.paymentType ? (booking.paymentType.toLowerCase()==='bill to company'?'PO':'Card'): null"  
                        matTooltipClass="booking-table-tooltip">
                          {{booking.paymentType ? (booking.paymentType.toLowerCase()==='bill to company'?'PO':'Card'): ''}}
                        </div>
                       </td>


                      


                      

                      </ng-container>
                                        <td>
                        <div [ngClass]="{'disabled': booking.bookingStatus === 'CANCELLED'}">
                          <!-- <app-status-cards [booking]="getBookingStatusObj(booking)"></app-status-cards> -->
                        </div>
                      </td>
                      <td
                        [ngClass]="{'cancelled-booking': booking.bookingStatus === 'CANCELLED' || (authService && (authService.user.role === 'VENDOR_MANAGER') && (booking.vendorStatus === 'CANCELLED' || booking.vendorStatus === 'DENIED'))}"
                        class="booking-actions-table-data">
                        <div class="booking-item-actions">
                          <app-booking-action
                            *ngIf="bookingActionBtnConfigObj && bookingActionsConfigObj && cancelPopUpConfig"
                            [config]="config" [bookingActionsConfigObj]="bookingActionsConfigObj"
                            [bookingActionConfig]="bookingActionConfig"
                            [bookingActionBtnConfigObj]="bookingActionBtnConfigObj" [booking]="booking"
                            [vendors]="vendors" [miscelleneousConfig]="miscelleneousConfig"
                            [vendorSelectConfigObj]="vendorSelectConfigObj" [selectedBookings]="selectedBookings"
                            [editCutOffDetails]="editCutOffDetails" [cancelCutOffDetails]="cancelCutOffDetails"
                            [cancelPopupConfig]="cancelPopUpConfig.elementConfigList[0]"
                            (showCancelBookingSuccessCallback)="showCancelBookingSuccess()"
                            (showCancelBookingErrorCallback)="showCancelBookingErrors($event)"
                            (toggleLoadingCallBack)="toggleLoading($event)"
                            (showBookingHistoryCallback)="showBookingHistory($event)"
                            (toggleAutoReload)="toggleAutoReload($event)"
                            (handleBookingsUpdateCallback)="handleManagaerAndVendorStatusApproval($event)"
                            (showSuccessToast)="showSuccessToast($event)"
                            [cabAllocationConfigObj]="cabAllocationConfigObj"
                            [vendorCabSelectFormGroup]="vendorCabSelectFormGroup" [unsortedData]="unsortedData"
                            [elementType]="tabularConfigObj.get('Cab').elementType"
                            [cabAllocationConfig]="cabAllocationConfig"
                            [showAvailableCabsConfig]="commonService?.workflowConfig?.showAvailablecabs"
                            [cabAllocationConfigObj]="cabAllocationConfigObj"
                            [isNonCompliantVisible]="commonService.workflowConfig['showNonCompliantCabs']"
                            [isNonCompliantSelectable]="commonService.workflowConfig['allowNonCompltCabsAlloc']"
                            [cabFormControl]="vendorCabSelectFormGroup.get(booking.bookingId)?.get('cab')"
                            [cabOptionsFormControlValues]="vendorCabSelectFormGroup.get(booking.bookingId)?.get('cabOptions').value"
                            [commonService]="commonService" [driverForm]="driverForm" [driverList]="driverList"
                            (handleBookingsUpdateIndividualCallback)="handleBookingUpdate($event)"
                            (cabSelectValidationsCallback)="cabSelectValidations($event)"
                            (toggleAddCabCallback)="toggleAddCab($event)"
                            (isPopupOpen)="openVirtualCabPopUp(true, booking)"
                            (selectedBookingsVendorValuesReset)="selectedBookingsVendorValuesReset($event)"
                            (vendorCabMap)="formVendorCabMap($event)" (assignIndividual)="assignIndividual($event)"
                            (driverChangeCallBack)="driverChangeCallBack($event)"
                            (cancelVendorCabUpdateCallBack)="cancelVendorCabUpdateCallBack($event)"
                            (getselectedCab)="getCabData($event)" (getselectedDriver)="getDriverData($event)"
                            (virtualCabDriverDetails)="onVirtualCabSubmit($event)"
                            (clearAssignModalValues)="clearAssignModalValues($event)"
                            (showMarshallAssignmentToast)="showMarshallAssignmentToast($event)"
                            >
                          </app-booking-action>
                        </div>
                      </td>
                    </tr>

                    <ng-template [ngIf]="showToast">
                      <div class="snackbar">
                          <span><img [src]="toastMsg=='Marshal assignment failed' ? 'assets/ic-ui-error-24.svg' : 'assets/successWhite.svg' "
                                  alt="error"></span>
                          {{toastMsg}}
                      </div>
                   </ng-template>
                  </ng-container>
                </tbody>
              </table>
              <app-request-details-popover *ngIf="showRequestDetails && singleRequestDetails"
                [singleRequestDetails]="singleRequestDetails"
                (closeRequestDetailsCallback)="handleCloseRequestDetails()">
              </app-request-details-popover>
              <!-- <app-booking-details-popover *ngIf="showBookingDetails && singleBookingDetails"
              [singleBookingDetails]="singleBookingDetails" (closeBookingDetailsCallback)="handleCloseBookingDetails()">
            </app-booking-details-popover> -->
              <app-bookings-history *ngIf="showHistoryView" [bookingId]="bookingHistoryId"
                [miscelleneousConfig]="miscelleneousConfig" (toggleLoadingCallBack)="toggleLoading($event)"
                (handleCloseHistoryCallback)="handleCloseHistoryView()">
              </app-bookings-history>

              <app-popover *ngIf="showModal || failedBookings.length" size="actions-popover"
                (closeCallback)="dismissError()">

                <div popover-header *ngIf="showApproveModalTM && !failedBookings.length" class="action-header-wrapper">
                  <div>
                    <img src="../../../assets/images/assign_approve.svg" class="action-dialog-icon" alt="">
                  </div>
                  <div>
                    Approve Booking
                  </div>
                </div>
                <div popover-content *ngIf="showApproveModalTM && !failedBookings.length">
                  <div *ngIf="!eligibleBookings.length">
                    All booking(s) are in approved or rejected state already.
                  </div>
                  <div *ngIf="nonEligibleBookings.length">
                    Booking(s) {{nonEligibleBookings.join(", ")}} are in approved or rejected state already.
                  </div>
                  <div *ngIf="eligibleBookings.length" class="mt-20">
                    Bookings(s) {{eligibleBookings.join(", ")}} are eligible for approval.
                  </div>

                </div>
                <div popover-actions class="actions-section"
                  *ngIf="showApproveModalTM && !failedBookings.length || eligibleBookings.length">
                  <app-button class="mr-10" type="primaryFilled" text="Okay"
                    (clickCallback)="approveAndAcceptBookings()">
                  </app-button>
                </div>


                <div popover-header *ngIf="showAcceptModalVM && !failedBookings.length">
                  Accept Booking
                </div>

                <div popover-content *ngIf="showAcceptModalVM && !failedBookings.length">
                  <ng-container *ngIf="!eligibleBookings.length">
                    All booking are in accepted or denied state already.
                  </ng-container>
                  <div *ngIf="nonEligibleBookings.length && eligibleBookings.length">
                    Booking(s) {{nonEligibleBookings.join(", ")}} are in accepted or denied state already.
                  </div>
                  <div *ngIf="eligibleBookings.length" class="mt-20">
                    Bookings(s) {{eligibleBookings.join(", ")}} are eligible for acceptance.
                  </div>

                </div>

                <div popover-actions class="actions-section"
                  *ngIf="showAcceptModalVM && !failedBookings.length && eligibleBookings.length">
                  <app-button class="mr-10" type="primaryFilled" text="Okay"
                    (clickCallback)="approveAndAcceptBookings()">
                  </app-button>
                </div>


                <div popover-header *ngIf="showDenyModalVM && !failedBookings.length">
                  Deny Booking
                </div>

                <div popover-content *ngIf="showDenyModalVM && !failedBookings.length">
                  <ng-container *ngIf="!showDenyReasonBlock else reasonBlock">
                    <div *ngIf="!eligibleBookings.length">
                      All booking are in accepted or denied state already.
                    </div>
                    <div *ngIf="nonEligibleBookings.length && eligibleBookings.length">
                      Booking(s) {{nonEligibleBookings.join(", ")}} are in accepted or denied state already.
                    </div>
                    <div *ngIf="eligibleBookings.length" class="mt-20">
                      Bookings(s) {{eligibleBookings.join(", ")}} are eligible for denial.
                    </div>
                  </ng-container>
                </div>
                <div popover-actions class="actions-section"
                  *ngIf="showDenyModalVM && !failedBookings.length && !showDenyReasonBlock && eligibleBookings.length">
                  <app-button class="mr-10" type="cancel" text="Cancel" (clickCallback)="cancelCallback()">
                  </app-button>
                  <app-button class="mr-10" type="primaryFilled" text="Continue"
                    (clickCallback)="showDenyReasonBlock = true">
                  </app-button>
                </div>


                <div popover-header *ngIf="isRejectActionSelected && !failedBookings.length"
                  class="action-header-wrapper">
                  <div>
                    <img src="../../../assets/cancel.svg" class="action-dialog-icon" alt="" style="width: 16px;">
                  </div>
                  <div>
                    Reject Booking
                  </div>
                </div>

                <div popover-content *ngIf="isRejectActionSelected && !failedBookings.length">
                  <ng-container *ngIf="!showRejectReasonBlock else reasonBlock">
                    <div *ngIf="!eligibleBookings.length">
                      All booking are in approved or rejected state already.
                    </div>
                    <div *ngIf="nonEligibleBookings.length && eligibleBookings.length">
                      Booking(s) {{nonEligibleBookings.join(", ")}} are in approved or rejected state already.
                    </div>
                    <div *ngIf="eligibleBookings.length" class="mt-20">
                      Bookings(s) {{eligibleBookings.join(", ")}} are eligible for rejection.
                    </div>
                  </ng-container>
                </div>
                <div popover-actions class="actions-section"
                  *ngIf="isRejectActionSelected && !failedBookings.length && !showRejectReasonBlock && eligibleBookings.length">

                </div>
                <div popover-actions
                  *ngIf="isRejectActionSelected && !failedBookings.length && !showRejectReasonBlock && !eligibleBookings.length">

                  <app-button class="mr-10" type="primaryFilled" text="Okay" (clickCallback)="cancelCallback()">
                  </app-button>
                </div>

                <div *ngIf="failedBookings.length" popover-header class="error-header">
                  <img src="assets/images/error.svg" alt="">
                  <span class="fs-14 font-weight-700 ">Error</span>
                </div>
                <div popover-content class="error-table-wrapper" *ngIf="failedBookings.length">
                  <table class="error-table">
                    <thead class="error-table-head">
                      <th class="column-header">Booking ID</th>
                      <th class="column-header">Error</th>
                    </thead>
                    <tbody class="error-table-body">
                      <tr class="error-table-row" *ngFor="let error of this.failedBookings">
                        <td class="ellipsis">{{error.bookingId}}</td>
                        <td class="ellipsis text-wrap">{{error.error}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>


                <ng-template #reasonBlock>

                  <div popover-content class="reject-booking-section">
                    <div class="mb-10 reason-container ">Please provide the reason <span class="optional"
                        *ngIf="!rejectDenyPopupConfig?.config?.mandatory">(optional)</span>
                    </div>
                    <textarea class="reject-text-area" name="reason" [(ngModel)]="reasonText" [maxlength]="maxLimit"
                      [required]="rejectDenyPopupConfig?.config.visibility.visible && rejectDenyPopupConfig?.config?.mandatory"
                      #reasonControl="ngModel" rows="3">
                    </textarea>
                    <div *ngIf="reasonControl.invalid">
                      <div class="error-msg" *ngIf="isSubmitReasonClicked && reasonControl.errors.required">This Field
                        is
                        mandatory</div>
                      <div class="error-msg" *ngIf="reasonControl.errors.maxlength">Limit Exceeded (Max limit - 200
                        characters)</div>
                    </div>
                  </div>
                  
                  <div popover-actions class="mt-20 actions-section">
                    <app-button class="mr-10" type="plainText" text="Cancel" (clickCallback)="cancelCallback()">
                    </app-button>
                    <app-button type="primaryFilled" text="Submit" (clickCallback)="submitReasonAndReject()">
                    </app-button>
                  </div>
                 

                </ng-template>

              </app-popover>



              <app-dialog *ngIf="updateBookingError && !failedBookings.length" type="alert" [buttonText]="['Okay']"
                (approveCallback)="dismissError()">
                {{updateBookingErrorMessage || globalError}}
              </app-dialog>

              <app-dialog *ngIf="showDialog" type="alert" [buttonText]="['Okay']" (approveCallback)="dismissError()">
                <span *ngIf="noDriverOrCab === 'noCab'">Please select the cab from the list</span>
                <span *ngIf="noDriverOrCab === 'noDriver'">Please select the driver from the list</span>
              </app-dialog>

              <app-toast *ngIf="showUpdateSuccess" [message]="successMessage || globalSuccess"
                (dismissCallback)="toggleSuccessToast()">
              </app-toast>

              <app-add-cab-form [booking]="addCabForBooking" [validateRegNo]="isIndianCountry"
                *ngIf="isAddCabFormVisible" (addCallback)="addCabResponse($event)" (closeCallback)="toggleAddCab()">
              </app-add-cab-form>

            </div>
          </div>


        </ng-template>

      </div>
    </div>
  </div>
</div>

<app-dialog class="cancel-bookings-dialog" *ngIf="downloadReportFailed" titleText="Download failed" type="alert"
  [buttonText]="['Okay']" (approveCallback)="hideDownloadReportError()">
  {{downloadReportFailed}}
</app-dialog>

<app-dialog class="cancel-bookings-dialog" *ngIf="requestRaised" titleText="Generate Report"  type="alert" [buttonText]="['Okay']" (approveCallback)="hideGenerateReport()">
  {{requestRaised}}
</app-dialog>

<app-pagination 
[totalNoOfRows]="totalNoOfRows" 
[paginationId]="paginationId" 
[currentPageSize]="pageSize"
[pageIndex]="pageIndexNew" 
[range]="range" 
[totalPages]="totalPages" 
[currentPage]="currentPage+1" 
[showPerPageSize]="true"
(changePage)="pageChanged($event)" 
(changeTableSize)="handlePageSizeChange($event)">
</app-pagination>
